/**
 * Validation utilities for Drawdown Tool forms
 */

/**
 * Validation rules for each step
 */
const VALIDATION_RULES = {
  location: [
    {
      field: "latitude_dd",
      validate: (value) => {
        if (!value) return "Latitude is required";
        const lat = parseFloat(value);
        if (isNaN(lat)) return "Invalid latitude format";
        if (lat < -90 || lat > 90) return "Latitude must be between -90 and 90";
        return null;
      },
    },
    {
      field: "longitude_dd",
      validate: (value) => {
        if (!value) return "Longitude is required";
        const lon = parseFloat(value);
        if (isNaN(lon)) return "Invalid longitude format";
        if (lon < -180 || lon > 180)
          return "Longitude must be between -180 and 180";
        return null;
      },
    },
    {
      field: "coordinates",
      validate: (value, formData) => {
        if (!formData.latitude_dd || !formData.longitude_dd) {
          return "Both latitude and longitude are required";
        }
        return null;
      },
    },
  ],
  wellDetails: [
    {
      field: "proposed_well_name",
      validate: (value) => (!value ? "Proposed Well ID is required" : null),
    },
    {
      field: "aquifer_ndx",
      validate: (value) => (!value ? "Source Aquifer is required" : null),
    },
    {
      field: "distance_radius",
      validate: (value) => {
        if (!value) return "Maximum Search Radius is required";
        if (parseFloat(value) <= 0) return "Must be greater than 0";
        return null;
      },
    },
    {
      field: "distance_units",
      validate: (value) => (!value ? "Units are required" : null),
    },
    {
      field: "proposed_annual_af",
      validate: (value) => {
        if (!value) return "Annual Production is required";
        if (parseFloat(value) <= 0) return "Must be greater than 0";
        return null;
      },
    },
    {
      field: "proposed_rate_gpm",
      validate: (value) => {
        if (!value) return "Discharge Rate is required";
        if (parseFloat(value) <= 0) return "Must be greater than 0";
        return null;
      },
    },
  ],
  customInputs: [
    {
      field: "custom_transmissivity",
      validate: (value, formData) => {
        if (formData.use_custom_t && !value) {
          return "Custom transmissivity is required when enabled";
        }
        return null;
      },
    },
    {
      field: "custom_storativity",
      validate: (value, formData) => {
        if (formData.use_custom_s && !value) {
          return "Custom storativity is required when enabled";
        }
        return null;
      },
    },
  ],
  notes: [], // No validation for notes step
};

/**
 * Validates a specific step of the form
 * @param {number} stepIndex - The step index (0-based)
 * @param {Object} formData - The form data to validate
 * @returns {Object} Object containing validation errors
 */
export const validateStep = (stepIndex, formData) => {
  const stepNames = ["location", "wellDetails", "customInputs", "notes"];
  const stepName = stepNames[stepIndex];

  if (!stepName || !VALIDATION_RULES[stepName]) {
    return {};
  }

  const errors = {};
  const rules = VALIDATION_RULES[stepName];

  for (const rule of rules) {
    const error = rule.validate(formData[rule.field], formData);
    if (error) {
      errors[rule.field] = error;
    }
  }

  return errors;
};
